import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";

export default function holdreasonsList(component) {
  const Authorization = "bearer " + localStorage.getItem("token");
  // parentComponent.setState({ isLoading: true });
  fetch(`${API_URL}rest/V1/picker/getReasons`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept, Authorization },
    body: JSON.stringify({
      user_type: "rider",
      reason_type: "on_hold",
    }),
  })
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      return response.json();
    })
    .then(function (data) {
      console.log("holdReasonAction", data);
      component.props.holdReasonAction(data);
    });
  // parentComponent.setState({ isLoading: false });
}



// WEBPACK FOOTER //
// ./src/utility/api/getholdReasons.js